import barrySpears from "../../public/images/avatars/barry-spears-100x100.jpg";
import bobbyShoemaker from "../../public/images/avatars/bobby-shoemaker-100x100.jpg";
import drfLogo from "../../public/images/logos/daily-racing-form-logo-gray.png";
import fansCheeringMp4 from "../../public/videos/fans-cheering.mp4";
import fansCheeringOgg from "../../public/videos/fans-cheering.ogg";
import hrnLogo from "../../public/images/logos/horse-racing-nation-logo-gray.png";
import If from "../components/if";
import markAylward from "../../public/images/avatars/mark-aylward-100x100.jpg";
import matthewShifman from "../../public/images/avatars/matthew-shifman-100x100.jpg";
import paulickReportLogo from "../../public/images/logos/paulick-report-logo-gray.png";
import React from "react";
import redirectIfAuthenticated from "../components/higher-order/redirect-if-authenticated";
import SignupLink from "../components/signup-link";
import TwitterFollowButton from "../components/twitter-follow-button.jsx";

function LandingPage() {
  return (
    <div>
      <div className="hero hero--has-video">
        <div className="l-wrapper">
          <div className="l-content">
            <h2 className="hero_pre">
              Horse Racing Contests Daily
            </h2>

            <h1 className="hero_heading hero_heading--medium">
              <span className="hero_heading_strong">
                Pick A Game. Pick Your Horses. Win Cash!
              </span>

              <SignupLink className="hero_heading_cta">
                FREE Entry Today!
              </SignupLink>
            </h1>

            <h2 className="hero_sub">
              {window.env.landingPagePromotion}
            </h2>

            <p className="hero_cta">
              <SignupLink className="btn btn--large btn--primary btn--emphasis">
                Play Now
              </SignupLink>
            </p>
          </div>
        </div>

        <video autoPlay className="hero_video" loop>
          <source src={fansCheeringMp4} type="video/mp4" />

          <source src={fansCheeringOgg} type="video/ogg" />

          <span>
            Your browser does not support the video tag.
          </span>
        </video>
      </div>

      <div className="l-row l-row--brand-color">
        <div className="l-wrapper">
          <div className="l-content">
            <h2 className="text-large text-center">
              Over $25 Million Paid Out!
            </h2>
          </div>
        </div>
      </div>

      <div className="l-row l-row--white">
        <div className="l-wrapper">
          <div className="l-content">
            <div className="batch-g batch-g--gutter">
              <div className="batch-c-1-1 batch-c-md-1-2">
                <div className="media media--padded">
                  <div className="media_graphic">
                    <i className="dw-dollars" />
                  </div>

                  <div className="media_body">
                    <h2 className="media_heading">
                      Play for CASH
                    </h2>

                    <p className="media_text">
                      Enter cash games for as little as $1 or higher stakes games for more. Get started winning cash today!
                    </p>

                    <SignupLink className="btn btn--primary">
                      Create FREE Account Now
                    </SignupLink>
                  </div>
                </div>
              </div>

              <div className="batch-c-1-1 batch-c-md-1-2">
                <div className="media media--padded">
                  <div className="media_graphic">
                    <i className="dw-points" />
                  </div>

                  <div className="media_body">
                    <h2 className="media_heading">
                      Play for FREE
                    </h2>

                    <p className="media_text">
                      Create your FREE account and get 1,000 player points. Use your points to enter free games and get started!
                    </p>

                    <SignupLink className="btn btn--primary">
                      Create FREE Account Now
                    </SignupLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="l-row l-row--brand-color">
        <div className="l-wrapper">
          <div className="l-content">
            <h2 className="text-larger text-center">
              How To Play
            </h2>

            <div className="batch-g batch-g--gutter batch-g--padding">
              <div className="batch-c-1-1 batch-c-md-1-3">
                <div className="blurb blurb--medium">
                  <div className="blurb_graphic">
                    <i className="dw-document-edit" />
                  </div>

                  <h2 className="blurb_heading">
                    Create your FREE
                    {window.env.brandName}

                    {" "}
                    Account
                  </h2>

                  <p />
                </div>
              </div>

              <div className="batch-c-1-1 batch-c-md-1-3">
                <div className="blurb blurb--medium">
                  <div className="blurb_graphic">
                    <i className="dw-horse-running-jockey" />
                  </div>

                  <h2 className="blurb_heading">
                    Pick a Horse in Each Race
                  </h2>

                  <p />
                </div>
              </div>

              <div className="batch-c-1-1 batch-c-md-1-3">
                <div className="blurb blurb--medium">
                  <div className="blurb_graphic">
                    <i className="dw-moneybag" />
                  </div>

                  <h2 className="blurb_heading">
                    Start winning real cash today!
                  </h2>

                  <p />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="l-row l-row--white l-row--bottom-border">
        <div className="l-wrapper">
          <div className="l-content">
            <h2 className="text-center">
              What Our Players Have To Say:
            </h2>

            <div className="batch-g batch-g--gutter">
              <div className="batch-c-1-1 batch-c-md-1-2">
                <div className="media media--medium media--quote media--padded">
                  <div className="media_graphic">
                    <img src={matthewShifman} />
                  </div>

                  <div className="media_body">
                    <h2 className="media_heading">
                      Matthew Shifman
                    </h2>

                    <p className="media_text">
                      If you are looking to try to enter the very popular world of horse racing handicapping tournaments then
                      {window.env.brandName}

                      {" "}
                      is the place for you! There are tournaments in all sizes and for all budgets.
                    </p>
                  </div>
                </div>
              </div>

              <div className="batch-c-1-1 batch-c-md-1-2">
                <div className="media media--medium media--quote media--padded">
                  <div className="media_graphic">
                    <img src={markAylward} />
                  </div>

                  <div className="media_body">
                    <h2 className="media_heading">
                      Mark Aylward
                    </h2>

                    <p className="media_text">
                      This is life-changing money, such a huge game.
                      {window.env.brandName}

                      {" "}
                      -  great site, great games, great people!
                    </p>
                  </div>
                </div>
              </div>

              <div className="batch-c-1-1 batch-c-md-1-2">
                <div className="media media--medium media--quote media--padded">
                  <div className="media_graphic">
                    <img src={barrySpears} />
                  </div>

                  <div className="media_body">
                    <h2 className="media_heading">
                      Barry Spears
                    </h2>

                    <p className="media_text">
                      I would HIGHLY recommend anyone, from the most experienced veteran to the beginning horseplayer, to join
                      {window.env.brandName}

                      {" "}
                      and start making $$$.  Simply put,

                      {window.env.brandName}

                      {" "}
                      is a GREAT place to play and I can’t say enough about it.
                    </p>
                  </div>
                </div>
              </div>

              <div className="batch-c-1-1 batch-c-md-1-2">
                <div className="media media--medium media--quote media--padded">
                  <div className="media_graphic">
                    <img src={bobbyShoemaker} />
                  </div>

                  <div className="media_body">
                    <h2 className="media_heading">
                      Bobby Shoemaker
                    </h2>

                    <p className="media_text">
                      The best horse racing tournament site in the world. Not only are there tons of tournament options each day with a plethora of chances to win a ton of money, they are also very good to the handicappers that play on their site.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <If className="l-row l-row--lighter-gray l-row--bottom-border" condition={window.env.socialMedia.showSocialMedia}>
        <div className="l-wrapper">
          <div className="l-content">
            <h3 className="text-center opacity--is-50">
              Join The
              {window.env.brandName}

              {" "}
              Community!
            </h3>

            <h2 className="text-large text-center opacity--is-75">
              Follow Us
            </h2>

            <div className="batch-g batch-g--gutter batch-g--align-center text-center">
              <div className="batch-c-1-1 batch-c-lg-1-8" />

              <If className="batch-c-1-1 batch-c-md-1-2 batch-c-lg-3-8" condition={window.env.socialMedia.facebook.show}>
                <div className="media display--is-inline-block text-left">
                  <div className="media_graphic">
                    <i className="dw-facebook-square" />
                  </div>

                  <div className="media_body">
                    <h2 className="media_heading">
                      Facebook
                    </h2>

                    <p className="media_text">
                      <span className="fb-like" data-action="like" data-href={window.env.socialMedia.facebook.url} data-layout="button_count" data-share="false" data-show-faces="false" />
                    </p>
                  </div>
                </div>
              </If>

              <If className="batch-c-1-1 batch-c-md-1-2 batch-c-lg-3-8" condition={window.env.socialMedia.twitter.show}>
                <div className="media display--is-inline-block text-left">
                  <div className="media_graphic">
                    <i className="dw-twitter" />
                  </div>

                  <div className="media_body">
                    <h2 className="media_heading">
                      Twitter
                    </h2>

                    <p className="media_text">
                      <TwitterFollowButton handle={window.env.socialMedia.twitter.handle} />
                    </p>
                  </div>
                </div>
              </If>

              <div className="batch-c-1-1 batch-c-lg-1-8" />
            </div>
          </div>
        </div>
      </If>

      <div className="l-row l-row--white">
        <div className="l-wrapper">
          <div className="l-content text-center">
            <h2 className="text-center">
              As Seen On:
            </h2>

            <ul className="logo-list">
              <li>
                <img alt="Horse Racing Nation" src={hrnLogo} />
              </li>

              <li>
                <img alt="Daily Racing Form" src={drfLogo} />
              </li>

              <li>
                <img alt="Paulick Report" src={paulickReportLogo} />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default redirectIfAuthenticated(LandingPage, "/tournaments");
